import { valueConverter } from 'aurelia';
import { formatDate } from '../services/date-format.service';

@valueConverter('date')
export class DateValueConverter {
  public toView(value: string | Date | null | undefined): string {
    return formatDate(value);
  }
}
